<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-svg icon-chevron-right"
  >
    <path d="M8.50000025,3.5 C8.23345619,3.5 7.9797439,3.60515475 7.79436485,3.79186626 C7.60515479,3.97974386 7.5,4.23345612 7.5,4.5 C7.5,4.76654424 7.6051547,5.02025655 7.79311345,5.20688725 L14.5866708,12 L7.79311335,18.7931208 C7.63617347,18.9500607 7.53724912,19.1515407 7.50863378,19.3683261 L7.5,19.5 C7.5,19.7665498 7.60515329,20.0202627 7.79436485,20.2081417 C7.98264435,20.3950953 8.23457613,20.5 8.50000025,20.5 C8.76654382,20.5 9.02025615,20.3948537 9.20688715,20.2068947 L16.3535574,13.0602244 C16.6360023,12.7777795 16.7926708,12.3999319 16.7926708,12.0006707 C16.7926708,11.6011684 16.6365015,11.2227277 16.3542241,10.9404503 L9.20813424,3.79436485 C9.0202566,3.60515475 8.76654431,3.5 8.50000025,3.5 Z" />
  </svg>
</template>
